// Không được để trống
import dayjs from "dayjs";

export const required = (t) => (value) => !value ? t('required') : null

// Phải từ n đến m ký tự
export const lengthBetween = (min, max, t) => (value) => {
  if (!value) return null
  return value.length < min || value.length > max
    ? t('must be {n} to {m} chars', { n: min, m: max })
    : null
}

// Không chứa kí tự đặc biệt
export const noSpecialChars = (t) => (value) =>
  !/^[A-Za-zÀ-ỹ.\s'’-\d]+$/.test(value) ? t('no special chars') : null

// Không được chứa số
export const noNumber = (t) => (value) =>
  /\d/.test(value) ? t('no numbers') : null

// Không được có khoảng trắng hai đầu của chuỗi
export const noLeadingTrailingSpaces = (t) => (value) =>
  /^\s|\s$/.test(value) ? t('no leading or trailing spaces') : null

// Không được có hai khoảng trắng liên tiếp
export const noDoubleSpaces = (t) => (value) =>
  /\s{2,}/.test(value) ? t('no consecutive spaces') : null

// Chữ đầu tiên phải viết hoa
export const firstLetterUppercase = (t) => (value) =>
  !/^[A-ZÀ-Ỹ]/.test(value) ? t('first letter must be uppercase') : null

// Mỗi từ trong chuỗi phải viết hoa chữ cái đầu - CHỈ bắt buộc ký tự ĐẦU mỗi từ viết hoa (đúng như
// message báo), không ép các ký tự sau đó phải viết thường. Trước đây dùng [a-zà-ỹ]* cho phần đuôi
// (chỉ nhận chữ thường) nên các từ viết hoa toàn bộ (bút danh dòng tu như "SJ", "OP", hậu tố "II"...)
// bị báo lỗi sai dù chữ đầu đã viết hoa đúng như yêu cầu.
export const eachWordUppercase = (t) => (value) =>
  !/^(?:[A-ZÀ-Ỹ][A-Za-zÀ-Ỹà-ỹ]*)(?:\s[A-ZÀ-Ỹ][A-Za-zÀ-Ỹà-ỹ]*)*$/.test(value)
    ? t('each word must start with uppercase')
    : null

// Ràng buộc email
export const emailFormat = (t) => (value) =>
  !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)
    ? t('invalid email address')
    : null

// Phải từ n đến m chữ số
export const digitLength = (min, max, t) => (value) =>
    !new RegExp(`^\\d{${min},${max}}$`).test(value)
        ? t('must be between {n} and {m} digits', { n: min, m: max })
        : null

// Ràng buộc passport hợp lệ
export const passportFormart = (t) => (value) =>
  !/^[A-Z]\d{7}$/.test(value)
    ? t('must start with an uppercase letter followed by 7 digits')
    : null

// Ràng buộc parish hợp lệ
export const parishFormart = (t) => (value) =>
  !/^([’']?[A-Za-zÀ-ỹ][A-Za-zÀ-ỹ'’.-]*)(\s[’']?[A-Za-zÀ-ỹ][A-Za-zÀ-ỹ'’.-]*)*$/.test(
    value
  )
    ? t('invalid template')
    : null

// Ràng buộc url
export const urlFormat = (t) => (value) => {
  if (!value) return null
  return !/^https:\/\//i.test(value)
      ? t('invalid url')
      : null
}

export const runRules = (value, rules) => {
  for (const rule of rules) {
    const error = rule(value)
    if (error) return error
  }
  return null
}

// Ngày phải SAU 1 ngày mốc khác (vd "ngày kết thúc" so với "ngày bắt đầu") - mặc định inclusive=false
// (BẮT BUỘC sau, bằng ngày mốc cũng là lỗi - case hay bị bỏ sót khi tự viết tay so sánh isBefore()).
// Dùng được cả 2 kiểu form đang có trong codebase: qua runRules() (rule-factory, vd CourseSetForm.js)
// lẫn gọi trực tiếp dateAfter(from, t)(to) trong khối validate viết tay (vd TimetableForm.js).
export const dateAfter = (compareValue, t, {inclusive = false} = {}) => (value) => {
  if (!value || !compareValue) return null
  const current = dayjs(value).startOf('day')
  const compare = dayjs(compareValue).startOf('day')
  const isValid = inclusive ? !current.isBefore(compare) : current.isAfter(compare)
  if (isValid) return null
  return t(
    inclusive ? 'date must be same as or after {date}' : 'date must be after {date}',
    {date: compare.format('DD/MM/YYYY')}
  )
}

// Đánh dấu 1+ field "touched" NGAY khi user tương tác (chọn ngày, chọn option...) - không đợi blur.
// Field điều khiển custom (DatePicker/Select...) hầu hết KHÔNG tự trigger blur như input thường, nên
// lỗi validate (đã chạy đúng qua validateOnChange) vẫn bị ẨN cho tới khi field được touched - xem
// gate touched[name] ? errors[name] : undefined ở FieldsFactory.js. Gọi hàm này ngay trong onChange
// để lỗi hiện NGAY trên màn hình, không cần đợi submit mới thấy.
export const touchFields = (form, ...names) => {
  names.forEach((name) => form.setFieldTouched(name, true, false))
}

// không được là ngày tương lai
export const validDate = (t) => (value) => {
  if (!value) return null

  return dayjs(value).isValid()
      ? null
      : t('invalid date')
}

// không được là ngày tương lai
export const notFutureDate = (t) => (value) => {
  if (!value) return null

  return dayjs(value).isAfter(dayjs(), 'day')
      ? t('birthday cannot be in the future')
      : null
}

// Thấp nhất của tuổi
export const minimumAge = (age, t) => (value) => {
  if (!value) return null

  return dayjs().diff(dayjs(value), 'year') < age
      ? t('minimum age is {n}', {n: age})
      : null
}

// Cao nhất của tuổi
export const maximumAge = (age, t) => (value) => {
  if (!value) return null

  return dayjs().diff(dayjs(value), 'year') > age
      ? t('maximum age is {n}', {n: age})
      : null
}